module.exports = __webpack_public_path__ + "static/media/wmTrial-words-1.4458c3c2.mp3";